export default "__VITE_ASSET__BZrgtCSi__"